<div class="container-fluid ml-n2">
  <div class="col-12 mt-2">
    <label class="sub-title-style">{{ $t(selectedSystemName) }}</label>
  </div>
  <div class="row mt-3">
    <div class="col-12 individual-container-array-style">
      <div v-for="item in individualListItems" class="m-2 individual-function-container function-hover"
        v-on:click="clickItem(item.route_name)">
        <div v-if="item.isSpecial" class="function-label text-center">*{{$t(item.name)}}</div>
        <div v-else class="function-label text-center">{{$t(item.name)}}</div>
      </div>
    </div>
  </div>

  <!-- 特殊キー入力対応 -->
  <b-modal v-model="showInputPasswordModal" size="md" :header-bg-variant="headerColor" header-text-variant="light"
    no-close-on-backdrop no-close-on-esc centered no-stacking>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ headerTitle }}
      </div>
    </template>

    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="w-100">
          <div class="box-margin-right individual-message">
            <div v-html="displayMessage()"></div>
          </div>
          <b-form-group v-if="showInputFormAndCancelButton">
            <b-form-input type="password" v-model="password" autocomplete="new-password"
              :state="validateParam && !validateParam.valid" size="sm" />
            <b-form-invalid-feedback v-if="validateParam"> {{ validateParam.msg }} </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
    </b-overlay>

    <template v-slot:footer="{ close, ok }">
      <div class="w-100 text-center">
        <b-button v-if="showInputFormAndCancelButton" size="sm" variant="outline-primary" @click="initInputKeyInfo"
          class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" variant="primary" @click="onOkClicked" class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>